const Roles = {
  STUDENT: 'student',
  CONFIGURATOR: 'configurator',
  TEACHER: 'teacher',
  EDITOR: 'editor',
  ADMIN: 'admin'
};

const fillsRole = function (role, roleToFill) {
  const castRole = role ? role.toLowerCase() : null;
  switch (castRole) {

    case Roles.STUDENT:
      return (roleToFill === Roles.STUDENT);
      break;

    case Roles.CONFIGURATOR:
      return (roleToFill === Roles.STUDENT || roleToFill === Roles.CONFIGURATOR);
      break;

    case Roles.TEACHER:
      return (roleToFill === Roles.STUDENT || roleToFill === Roles.TEACHER || roleToFill === Roles.CONFIGURATOR);
      break;

    case Roles.EDITOR:
      return [Roles.STUDENT, Roles.TEACHER, Roles.EDITOR, Roles.CONFIGURATOR].includes(roleToFill);
    case Roles.ADMIN:
      return true;
      break;

    default:
      return false;
  }
};

exports.Roles = Roles;
exports.fillsRole = fillsRole;

